import { useTranslation } from "react-i18next";
import type { CheckFinding } from "../../../api/content/reviewDecoders";
import { Term } from "../page/TripleList";
import ItemReferenceName from "../../items/ItemReferenceName";
import { findingFocus, itemVersionReference } from "./checkFindings";

const NO_LABELS: Readonly<Record<string, string>> = {};

/** One finding renderer for check results and merge blocks; old results hold only messages. */
export default function CheckFindingView({ finding, labels = NO_LABELS, technical = false }: {
  finding: Pick<CheckFinding, "message"> & Partial<Pick<CheckFinding, "focus">>;
  labels?: Readonly<Record<string, string>>;
  technical?: boolean;
}) {
  const { t } = useTranslation();
  const focus = findingFocus(finding.focus ?? null, labels);
  // An item version no label names is named by the item name cache, not by its hash (IM-RULES).
  const unnamed = focus?.kind === "term" && focus.label === null ? itemVersionReference(finding.focus ?? null) : null;
  const shown = focus === null ? t("reviews.mergeBlocks.noFocus") : unnamed !== null ? <ItemReferenceName reference={unnamed} showVersion={false} /> : <Term term={focus} />;
  return (
    <>
      {finding.focus !== undefined ? <>{shown}{": "}</> : null}
      {finding.message}
      {technical && finding.focus != null ? <span className="block"><code className="break-all font-mono text-xs">{finding.focus}</code></span> : null}
    </>
  );
}
